<template>
  <div class="audio-player">
    <span class="audio-player__time">{{item.timestamp | shortestTime}}</span>
    <audio ref="audio" :src="audioURL(item.audio.path)" class="audio-player__audio"
    @loadeddata="canplay = true"
    @ended="playing=false"></audio>
    <div class="audio-player__button" v-if="canplay">

      <svg v-if="playing" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" @click.prevent="pause()">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" fill="#2B974C"/>
      </svg>

      <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" @click.prevent="play()">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" fill="#ffffff"/>
      </svg>

    </div>
    <slot v-bind:item="item">
    <span class="audio-player__title">{{text}}</span>
    </slot>
  </div>
</template>

<script>
  import compact from 'lodash/compact'

  const assetHost = 'http://d11u6129i78zcf.cloudfront.net'
  
  const shortestTime = (timestamp) => {
    const parts = (new Date(timestamp)).toGMTString().split(' ')
    return `${parts[2]} ${parts[3]}`
  }

  export default {
    name: 'UMAudioPlayer',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        playing: false,
        canplay: false
      }
    },
    computed: {
      text() {
        const {title,data,location} = this.item
        const inout = data.are_you_indoors_or_outdoors ? (data.are_you_indoors_or_outdoors === 'Indoors' ? 'indoor' : 'outdoor') : null
        const locationName = location ? (location.display_name || location.full_name || location.name) : null
        return compact([title, inout, locationName]).join(' | ')
      }
    },
    mounted () {
      if (/iPad|iPhone|iPod/.test(window.navigator.userAgent))
        this.canplay = true
    },
    methods: {
      play () {
        this.$refs.audio.play()
        this.playing = true
        this.$emit('play', this)
      },
      pause () {
        this.$refs.audio.pause()
        this.playing = false
      },
      audioURL (path) {
        return `${assetHost}/assets${path}`
      }
    },
    filters: {
      shortTime (timestamp) {
        const parts = (new Date(timestamp)).toGMTString().split(' ')
        return `${parts[1]} ${parts[2]} ${parts[3]}`
      },
      shortestTime (timestamp) {
        return shortestTime(timestamp)
      },
    }
  }
</script>
